import { createFileRoute } from '@tanstack/react-router';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { DevDocumentAddPage } from './-components/DevDocumentAddPage';

/**
 * 開発ドキュメント 新規追加画面 (route 登録)。
 *
 * 本体実装は `-components/DevDocumentAddPage.tsx` に分離（mutation の重い
 * generic 推論を module 境界で route ファイルから切り離す）。
 * この route ファイルには `useDocumentTitle` + `useTranslation` しか置かない。
 */
export const Route = createFileRoute('/_stacktrace/development-documents/add/')({
  component: DevDocumentAddRouteComponent
});
function DevDocumentAddRouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'devDocuments.add'
  });
  useDocumentTitle(t('documentTitle'));
  return <DevDocumentAddPage />;
}